/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DarResponseDto
 */
export interface DarResponseDto {
    /**
     * User Id
     * @type {string}
     * @memberof DarResponseDto
     */
    userId?: string;
}

/**
 * Check if a given object implements the DarResponseDto interface.
 */
export function instanceOfDarResponseDto(value: object): boolean {
    return true;
}

export function DarResponseDtoFromJSON(json: any): DarResponseDto {
    return DarResponseDtoFromJSONTyped(json, false);
}

export function DarResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DarResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function DarResponseDtoToJSON(value?: DarResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
    };
}

